import React from "react";
import { Link, type LinkProps } from "@jasperlabs/ui";

type Props = Omit<LinkProps<"a">, "href" | "children"> & {
	children: React.ReactNode;
};

const CARUSO_GENERAL_TERMS_URL =
	"https://www.getcaruso.com/en-us/general-terms";

function CarusoGeneralTermsLink({
	children,
	target = "_blank",
	rel,
	...props
}: Props) {
	return (
		<Link
			href={CARUSO_GENERAL_TERMS_URL}
			target={target}
			rel={rel ?? (target === "_blank" ? "noopener noreferrer" : undefined)}
			{...props}
		>
			{children}
		</Link>
	);
}

export default CarusoGeneralTermsLink;
